import { Button } from '@platform/ui-kit'
import { forwardRef } from 'react'

import { ArticleList, GuidesType } from '../blog/article-list'

import styles from './styles.module.scss'
type FromOurBlogSectionProps = {
  posts: GuidesType[]
}
export const FromOurBlogSection = forwardRef<HTMLElement, FromOurBlogSectionProps>(
  ({ posts }, ref) => {
    return (
      <section className={styles['article-section']} ref={ref}>
        <h2 className={styles['title']}>From our blog</h2>
        <Button className={styles['button']} href="/blog" size="large" prefetch={false}>
          Find more articles
        </Button>
        <ArticleList className={styles['article-list']} posts={posts} hideThirdCard />
      </section>
    )
  }
)

export default FromOurBlogSection
